export default function Skeleton(theme) {
  return {
    MuiSkeleton: {
      defaultProps: {
        animation: 'wave'
      },

      styleOverrides: {
        root: {
          transform: 'none', // Don't know why a transform applies by default
          maxWidth: 'initial',
          backgroundColor: theme.palette.background.neutral
        }
      }
    }
  };
}
